import React from "react";

import { useFormContext, useWatch } from "react-hook-form";
import Checkbox from "components/shared/form/fields/Checkbox";
import CheckboxFieldWrapper from "components/shared/form/fields/CheckboxFieldWrapper";
import RadioButton from "components/shared/form/fields/RadioButton";

type GroupAccessArgs = {
  sensitive: boolean;
  isActiveMainGroup: boolean;
  canCreateHidden: boolean;
};

export default function GroupAccess({
  sensitive,
  isActiveMainGroup,
  canCreateHidden,
}: GroupAccessArgs) {
  const { control } = useFormContext();
  const [access] = useWatch({ control, name: ["access"] });

  const access_options: {
    value: string;
    label: string;
    disabled?: boolean;
  }[] = [
    {
      value: "open",
      label: I18n.t("js.groups.form.open"),
      disabled: sensitive,
    },
  ];

  if (!isActiveMainGroup) {
    access_options.push({
      value: "closed",
      label: I18n.t("js.groups.form.closed"),
    });
  }
  if (canCreateHidden) {
    access_options.push({
      value: "hidden",
      label: I18n.t("js.groups.form.hidden"),
    });
  }

  return (
    <div className="form-horizontal">
      <RadioButton
        name="access"
        label={I18n.t("js.groups.form.access")}
        hint={
          isActiveMainGroup
            ? I18n.t("js.groups.form.access_change_disabled")
            : undefined
        }
        options={access_options}
      />
      {access !== "open" && (
        <CheckboxFieldWrapper
          hint={
            access != "hidden"
              ? I18n.t("js.groups.form.moderated_membership")
              : undefined
          }
        >
          {access != "hidden" && (
            <Checkbox
              name="moderated_join"
              label={I18n.t("js.groups.form.moderated_join")}
            />
          )}
          <Checkbox
            name="members_can_invite"
            label={I18n.t("js.groups.form.members_can_invite")}
          />
        </CheckboxFieldWrapper>
      )}
    </div>
  );
}
